<template>
  <div class="flex space-x-3 md:space-x-5 pl-5 md:pl-10 py-5 sticky bg-white -top-0 md:-top-6">
    <div
      v-for="legend in [['Non observable', 'bg-gray-600'], ['Non acquis', 'bg-pink-600'], ['En apprentissage', 'bg-indigo-300'], ['En évolution', 'bg-indigo-600'], ['Acquis', 'bg-teal-600']]"
      :key="legend[0]"
      class="flex flex-row space-x-1 md:space-x-2 h-3 md:h-5 justify-start md:items-center"
    >
      <div
        class="h-3 w-3 md:h-5 md:w-5 rounded-full"
        :class="legend[1]"
      />
      <div class="text-sm">
        {{ legend[0] }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CompetencesLegend'
};
</script>
